import CIQClient from "services/ciq-client";

async function exportCustomReportAsCSV(
  reportId: string,
  projectToken: string,
  payload: {
    flat_layout: boolean;
  }
) {
  const response = await CIQClient.post({
    url: `/report-engine/custom-report/${reportId}/export`,
    data: payload,
    config: { headers: { Authorization: `Bearer ${projectToken}` } },
    showError: false
  });

  return response;
}

async function getCustomReportData(reportId: string, projectToken: string) {
  const response = await CIQClient.get({
    url: `/report-engine/custom-report/${reportId}/data`,
    config: { headers: { Authorization: `Bearer ${projectToken}` } }
  });
  return response;
}

export { exportCustomReportAsCSV, getCustomReportData };
